/**
 * 预产期：从 当前月份 至 后12月
 */
export function getDueDates() {
  let m = new Date().getMonth() + 1
  let y = new Date().getFullYear()
  let count = 0
  let list = []
  while (count < 13) {
    if (m > 12) {
      m = 1
      y += 1
    }
    const id = y + '-' + (m < 10 ? '0' + m.toString() : m)
    list.push(id)
    m++
    count++
  }
  return list
}
